import { rootStateBranchSelector } from '../rootStateBranchSelector';

export const residentialComplexesIdsSelector = rootStateBranchSelector('residentialComplexesIds');
